<template>
  <v-card class="mx-auto">
    <v-card-title class="white--text">
      {{ $t("UserData.PROFILE_EDIT") }}
    </v-card-title>
    <v-card-text class="relative-position">
      <div class="clear-fix"></div>
      <v-row>
        <v-form ref="editForm" v-model="valid" lazy-validation>
          <v-col class="text-center" cols="12" order="1" order-md="0">
            <v-avatar
                v-if="hasImage"
                class="mx-auto"
                color="primary"
                size="128"
            >
              <img :src="profilePicture" alt="User Profile Image"/>
            </v-avatar>
            <v-chip
                v-if="hasImage"
                class="ma-2"
                color="transparent"
                text-color="error"
                @click="changeImageConfirm"
            >
              <v-icon>mdi-delete-circle</v-icon>
            </v-chip>
            <v-file-input
                v-if="!hasImage"
                v-model="profilePicture"
                :label="$t('UserData.AVATAR')"
                :rules="photoRules"
                :show-size="1000"
                accept="image/apng,image/bmp,image/gif,image/jpeg,image/png,image/webp"
                class="mt-4"
                color="primary"
                outlined
                prepend-icon="mdi-camera"
            >
              <template v-slot:selection="{ index, text }">
                <v-chip color="primary" dark>{{ text }}</v-chip>
              </template>
            </v-file-input>
          </v-col>
          <v-col cols="12" order="2" order-md="1">
            <v-expansion-panels v-model="panel" hover multiple>
              <v-expansion-panel>
                <v-expansion-panel-header
                    class="white--text expansion-header"
                    color="primary"
                >
                  {{ $t("UserData.PERSONAL_DATA") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mt-2">
                    <v-col cols="12" lg="6" md="12" sm="12">
                      <v-text-field
                          ref="arName"
                          v-model="arName"
                          :counter-value="counterValue"
                          :label="$t('UserData.AR_NAME')"
                          :rules="arNameRules"
                          clearable
                          counter
                          maxlength="100"
                          outlined
                      />
                    </v-col>
                    <v-col cols="12" lg="6" md="12" sm="12" xl="6">
                      <v-text-field
                          ref="enName"
                          v-model="enName"
                          :counter-value="counterValue"
                          :label="$t('UserData.EN_NAME')"
                          :rules="enNameRules"
                          clearable
                          counter
                          maxlength="100"
                          outlined
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" lg="6" md="12" sm="12">
                      <v-autocomplete
                          ref="nationalityCountry"
                          v-model="nationalityCountry"
                          :items="countriesComputed"
                          :label="$t('UserData.NATIONALITY')"
                          disabled
                          item-text="name"
                          item-value="id"
                          outlined
                          @change="cardID = ''"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" lg="6" md="12" sm="12" xl="6">
                      <v-radio-group
                          v-model="cardType"
                          color="primary"
                          disabled row>
                        <!--:disabled="nationalityCountry !== 1"-->
                        <v-radio
                            :label="$t('UserData.NATIONAL_ID')"
                            :value="1"
                            @change="cardID = ''"
                        ></v-radio>
                        <!--:disabled="nationalityCountry === 1"-->
                        <v-radio
                            :label="$t('UserData.PASSPORT')"
                            :value="2"
                            @change="cardID = ''"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                          v-if="cardType"
                          ref="cardID"
                          v-model="cardID"
                          :counter="cardType === 1 ? 14 : 25"
                          :label="
                          cardType === 1
                            ? $t('UserData.NATIONAL_ID')
                            : $t('UserData.PASSPORT')
                        "
                          :maxlength="cardType === 1 ? 14 : 25"
                          :rules="cardIDRules"
                          clearable
                          disabled
                          outlined
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" lg="4" md="4" sm="4">
                      <v-select
                          v-model="gender"
                          :items="genders"
                          :label="$t('UserData.GENDER')"
                          :readonly="cardType === 1"
                          disabled
                          item-text="value"
                          item-value="id"
                          outlined
                      ></v-select>
                    </v-col>

                    <v-col cols="4" lg="4" md="4" sm="4">
                      <v-select
                          v-model="religion"
                          :items="religions"
                          :label="$t('ADMISSION_DATA.STEP1.RELIGION')"
                          item-text="value"
                          item-value="id"
                          outlined
                      ></v-select>
                    </v-col>

                    <v-col cols="4" lg="4" md="4" sm="4" xl="4">
                      <!--:disabled="cardType === 1"-->
                      <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          disabled
                          min-width="290px"
                          offset-y
                          transition="scale-transition"

                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              ref="dOB"
                              v-model="dOB"
                              :label="$t('UserData.BIRTHDAY')"
                              :readonly="cardType === 1"
                              :rules="dOBRules"
                              append-icon="mdi-calendar"
                              disabled
                              outlined
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>

                        <v-date-picker
                            v-model="dOB"
                            :disabled="cardType === 1"
                            :max="maxDOB"
                            :min="minDOB"
                            no-title
                            @input="menu = false"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                  <!--           birth place        -->
                  <v-row>
                    <v-col cols="12">
                      <v-card class="pa-1 elevation-0">
                        <strong class="body-1">
                          {{ $t("UserData.BIRTHPLACE") }}:
                        </strong>
                      </v-card>
                    </v-col>
                    <v-col class="px-4" cols="12" lg="4" md="12" sm="12">
                      <v-autocomplete
                          ref="birthPlaceCountry"
                          v-model="birthPlaceCountry"
                          :items="birthCountriesFilter"
                          :label="$t('UserData.COUNTRY')"
                          :rules="requiredRule"
                          item-text="name"
                          item-value="id"
                          outlined
                          @change="getStates('birthPlace')"
                      ></v-autocomplete>
                    </v-col>
                    <v-col class="px-4" cols="12" lg="4" md="12" sm="12">
                      <v-autocomplete
                          ref="birthPlaceState"
                          v-model="birthPlaceState"
                          :items="birthStatesFilters"
                          :label="$t('UserData.STATE')"
                          :rules="(birthPlaceCountry !==1?'':requiredRule)"
                          item-text="name"
                          item-value="id"
                          outlined
                          @change="getCities('birthPlace')"
                      ></v-autocomplete>
                    </v-col>
                    <v-col class="px-4" cols="12" lg="4" md="12" sm="12">
                      <v-autocomplete
                          ref="birthPlaceCity"
                          v-model="birthPlaceCity"
                          :items="birthCitiesFilter"
                          :label="$t('UserData.CITY')"
                          :rules="(birthPlaceCountry !==1?'':requiredRule)"
                          item-text="name"
                          item-value="id"
                          outlined
                      ></v-autocomplete>
                    </v-col>
                  </v-row>

                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header
                    class="white--text expansion-header"
                    color="primary"
                >
                  {{ $t("UserData.CONTACT") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mt-2">
                    <v-col cols="12" lg="6" md="12" sm="12">
                      <v-text-field
                          ref="telephone"
                          v-model="telephone"
                          :label="$t('UserData.PHONE')"
                          :rules="phoneRules"
                          clearable
                          counter
                          maxlength="20"
                          outlined
                      />
                    </v-col>
                    <v-col cols="12" lg="6" md="12" sm="12" xl="6">
                      <vue-tel-input
                          v-model="mobile"
                          :class="
                          bindProps.inputClasses === 'error--text'
                            ? 'error--border'
                            : ''
                        "
                          :preferredCountries="['eg']"
                          :rules="[$store.state.rules.required]"
                          class="mb-2 body-1"
                          clearable
                          outlined
                          v-bind="bindProps"
                          @validate="IsValid"
                          @keydown.space="preventLeadingSpace"
                      >
                      </vue-tel-input>
                      <div
                          v-if="
                          !mobile || bindProps.inputClasses === 'error--text'
                        "
                          class="v-text-field__details ms-2"
                      >
                        <div
                            class="v-messages theme--light error--text"
                            role="alert"
                        >
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              {{
                                !mobile
                                    ? $t("REQUIRED_FIELD")
                                    : $t("MOBILE_VALIDATION")
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <!--           address        -->
                    <v-col cols="12">
                      <v-card class="pa-1 elevation-0">
                        <strong class="body-1">
                          {{ $t("UserData.ADDRESS") }}:
                        </strong>
                      </v-card>
                    </v-col>
                    <v-col class="px-4" cols="12" lg="4" md="12" sm="12">
                      <v-autocomplete
                          ref="addressCountry"
                          v-model="addressCountry"
                          :items="countriesComputed"
                          :label="$t('UserData.COUNTRY')"
                          :rules="requiredRule"
                          item-text="name"
                          item-value="id"
                          outlined
                          @change="getStates('address')"
                      ></v-autocomplete>
                    </v-col>
                    <v-col class="px-4" cols="12" lg="4" md="12" sm="12">
                      <v-autocomplete
                          ref="addressState"
                          v-model="addressState"
                          :items="statesComputed"
                          :label="$t('UserData.STATE')"
                          :rules="(addressCountry!==1?'':requiredRule)"
                          item-text="name"
                          item-value="id"
                          outlined
                          @change="getCities('address')"
                      ></v-autocomplete>
                    </v-col>
                    <v-col class="px-4" cols="12" lg="4" md="12" sm="12">
                      <v-autocomplete
                          ref="addressCity"
                          v-model="addressCity"
                          :items="citiesComputed"
                          :label="$t('UserData.CITY')"
                          :rules="(addressCountry!==1?'':requiredRule)"
                          item-text="name"
                          item-value="id"
                          outlined
                      ></v-autocomplete>
                    </v-col>

                    <!--           Email         -->
                    <v-col cols="12" lg="6" md="12" sm="12">
                      <v-text-field
                          ref="email"
                          v-model="email"
                          :label="$t('UserData.EMAIL')"
                          disabled
                          outlined
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header
                    class="white--text expansion-header"
                    color="primary"
                >
                  {{ $t("UserData.CERTIFICATE") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content
                    :disabled="pullFromGsApi===true"
                >
                  <v-row class="mt-2">
                    <v-col cols="12" lg="6" md="12" sm="12">
                      <v-autocomplete
                          ref="certificateType"
                          v-model="certificateType"
                          :disabled="pullFromGsApi===true"
                          :items="certificateTypesComputed"
                          :label="$t('UserData.CERTIFICATE_TYPE')"
                          :rules="requiredRule"
                          item-text="name"
                          item-value="id"
                          outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" lg="6" md="12" sm="12">
                      <v-autocomplete
                          ref="divisionType"
                          v-model="divisionType"
                          :disabled="pullFromGsApi===true"
                          :items="divisionTypesComputed"
                          :label="$t('UserData.CERTIFICATE_DEPT')"
                          :rules="(divisionTypesComputed.length>0?divisionTypeRule:[true])"
                          item-text="name"
                          item-value="id"
                          outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                        v-if="isEquationCertificate"
                        :disabled="pullFromGsApi===true"
                        cols="12"
                        lg="6"
                        md="12"
                        sm="12"
                    >
                      <v-autocomplete
                          ref="equationCertificateType"
                          v-model="equationCertificateType"
                          :disabled="pullFromGsApi===true"
                          :items="equationCertificateTypesComputed"
                          :label="$t('UserData.CERTIFICATE_EQ_TYPE')"
                          :rules="
                          isEquationCertificate ? requiredRule : nonRequiredRule
                        "
                          item-text="name"
                          item-value="id"
                          outlined
                      ></v-autocomplete>
                    </v-col>

                    <v-col
                        v-if="isEgyptianCertificate"
                        cols="12"
                        lg="6"
                        md="12"
                        sm="12"
                    >
                      <v-autocomplete
                          v-model="egyptianCertificate"
                          :items="egyptianCertificatesComputed"
                          item-text="name"
                          item-value="id"
                          :label="$t('UserData.CERTIFICATE_EGYPTIAN_TYPE')"
                          outlined
                      />
                    </v-col>

                    <v-col
                        v-if="isForeignCertificate"
                        cols="12"
                        lg="6"
                        md="12"
                        sm="12"
                    >
                      <v-autocomplete
                          ref="foreignCertificate"
                          v-model="foreignCertificate"
                          :disabled="pullFromGsApi===true"
                          :items="foreignCertificatesComputed"
                          :label="$t('UserData.CERTIFICATE_FOREIGN_TYPE')"
                          :rules="
                          isForeignCertificate ? requiredRule : nonRequiredRule
                        "
                          item-text="name"
                          item-value="id"
                          outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                        v-if="isAnotherEquationCertificate"
                        cols="12"
                        lg="6"
                        md="12"
                        sm="12"
                    >
                      <v-text-field
                          ref="otherCertificateText"
                          v-model="otherCertificateText"
                          :disabled="pullFromGsApi===true"
                          :label="$t('UserData.CERTIFICATE_OTHER')"
                          :rules="otherCertificateRules"
                          clearable
                          counter
                          maxlength="75"
                          outlined
                      />
                    </v-col>
                    <v-col cols="12" lg="6" md="12" sm="12">
                      <v-autocomplete
                          ref="preQualYear"
                          v-model="preQualYear"
                          :disabled="pullFromGsApi===true"
                          :items="yearsComputed"
                          :label="$t('UserData.CERTIFICATE_YEAR')"
                          :rules="requiredRule"
                          item-text="name"
                          item-value="id"
                          outlined
                          @change="$refs.total.resetValidation()"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" lg="6" md="12" sm="12">
                      <v-text-field
                          ref="total"
                          v-model="total"
                          :disabled="pullFromGsApi===true"
                          :label="$t('UserData.CERTIFICATE_RESULT')"
                          :rules="totalRules"
                          clearable
                          outlined
                      />
                    </v-col>
                    <v-col cols="12" lg="6" md="12" sm="12">
                      <v-autocomplete
                          ref="preQualCountry"
                          v-model="preQualCountry"
                          :disabled="!isEquationCertificate || pullFromGsApi===true"
                          :items="countriesComputed"
                          :label="$t('UserData.COUNTRY')"
                          :rules="requiredRule"
                          item-text="name"
                          item-value="id"
                          outlined
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
          <v-col cols="12" order="3">
            <v-btn
                :class="actionClassObject"
                :disabled="isSubmitting"
                color="primary"
                @click="submitForm"
            >
              {{ $t("SAVE") }}
            </v-btn>
            <v-btn :class="actionClassObject" color="dark" @click="cancel">
              {{ $t("CANCEL") }}
            </v-btn>
          </v-col>
        </v-form>
      </v-row>
    </v-card-text>
    <ad-confirmDialog ref="confirm"></ad-confirmDialog>
  </v-card>
</template>

<script>
import generalFunctions from "@/mixins/generalFunctions";
import ConfirmDialog from "@/components/shared/ConfirmDialog";
import serverTranslationsMixin from "@/mixins/serverTranslations.js";

export default {
  name: "Edit",
  mixins: [generalFunctions, serverTranslationsMixin],
  components: {
    "ad-confirmDialog": ConfirmDialog
  },
  computed: {
    egyptianCertificatesComputed() {
  return this.egyptianCertificates.map(item => ({
    id: item.id,
    name: this.serverTranslate(item.name)
  }));
},
    locale() {
      return this.$store.state.curLanguage;
    },
    isArabic() {
      return this.$store.state.direction;
    },
    actionClassObject() {
      return {
        "float-left mx-1 body-1": this.isArabic,
        "float-right mx-1 body-1": !this.isArabic
      };
    },
    genders() {
      return [
        {id: 13, value: this.$t("UserData.MALE")},
        {id: 14, value: this.$t("UserData.FEMALE")}
      ];
    },  religions() {
      return [
        {id: 84, value: this.$t( "ADMISSION_DATA.STEP1.MUSLIM")},
        {id: 85, value: this.$t( "ADMISSION_DATA.STEP1.CHRISTIAN")}
      ];
    },
    cardIDRules() {
      return this.cardType === 1
          ? this.$store.state.rules.NIDRulse
          : this.$store.state.rules.passportRulse;
    },
    countriesComputed() {
      let countries = [];
      this.countriesList.forEach(country => {
        countries.push(
            Object.assign(
                {},
                {
                  id: country.id,
                  name: this.serverTranslate(country.name)
                }
            )
        );
      });
      return countries;
    },
    statesComputed() {
      let states = [];
      if(this.addressStatesList){
        this.addressStatesList.forEach(state => {
        states.push(
            Object.assign(
                {},
                {
                  id: state.id,
                  name: this.serverTranslate(state.name)
                }
            )
        );
      });
      }
      return states;
    },
    citiesComputed() {
      let cities = [];
      if(this.addressCitiesList){
        this.addressCitiesList.forEach(city => {
        cities.push(
            Object.assign(
                {},
                {
                  id: city.id,
                  name: this.serverTranslate(city.name)
                }
            )
        );
      });
      }
      return cities;
    },

    birthCountriesFilter() {
      let countries = [];
      this.birthCountriesList.forEach(country => {
        countries.push(
            Object.assign(
                {},
                {
                  id: country.id,
                  name: this.serverTranslate(country.name)
                }
            )
        );
      });
      return countries;
    },
    birthStatesFilters() {
      let states = [];
      if (this.birthStatesList){
        this.birthStatesList.forEach(state => {
        states.push(
            Object.assign(
                {},
                {
                  id: state.id,
                  name: this.serverTranslate(state.name)
                }
            )
        );
      });
      }

      return states;
    },
    birthCitiesFilter() {
      let cities = [];
      if (this.birthCitiesList){
        this.birthCitiesList.forEach(city => {
        cities.push(
            Object.assign(
                {},
                {
                  id: city.id,
                  name: this.serverTranslate(city.name)
                }
            )
        );
      });
      }
      return cities;
    },

    certificateTypesComputed() {
      let certificateTypes = [];
      this.certificateTypes.forEach(certificateType => {
        certificateTypes.push(
            Object.assign(
                {},
                {
                  id: certificateType.id,
                  name: this.serverTranslate(certificateType.name)
                }
            )
        );
      });
      return certificateTypes;
    },
    divisionTypesComputed() {
      let divisionTypes = [];
      if ([15, 17].includes(this.certificateType)) {
        divisionTypes = this.divisionTypes.filter(division =>
            [18, 19].includes(division.id)
        );
      } else if ([77, 16].includes(this.certificateType)) {
        divisionTypes = this.divisionTypes.filter(division =>
            [19, 20, 21].includes(division.id)
        );
      } else if (this.certificateType === 62) {
        divisionTypes = this.divisionTypes.filter(division =>
            [63, 64, 81].includes(division.id)
        );
      } else if (this.certificateType === 78) {
        divisionTypes = this.divisionTypes.filter(division =>
            [63, 64, 80].includes(division.id)
        );
      }
      let divisionTypesData = [];
      divisionTypes.forEach(divisionType => {
        divisionTypesData.push(
            Object.assign(
                {},
                {
                  id: Number(divisionType.id),
                  name: this.serverTranslate(divisionType.name)
                }
            )
        );
      });
      return divisionTypesData;
    },
    equationCertificateTypesComputed() {
      if (this.certificateType === 17) {
        let equationCertificateTypes = [];
        this.equationCertificateTypes.forEach(equationCertificateType => {
          equationCertificateTypes.push(
              Object.assign(
                  {},
                  {
                    id: equationCertificateType.id,
                    name: this.serverTranslate(equationCertificateType.name)
                  }
              )
          );
        });
        return equationCertificateTypes;
      }
      return [];
    },
    foreignCertificatesComputed() {
      let foreignCertificates = [];
      this.foreignCertificates.forEach(foreignCertificate => {
        foreignCertificates.push(
            Object.assign(
                {},
                {
                  id: foreignCertificate.id,
                  name: this.serverTranslate(foreignCertificate.name)
                }
            )
        );
      });
      return foreignCertificates;
    },
    yearsComputed() {
      let years = [];
      this.years.forEach(year => {
        years.push(
            Object.assign(
                {},
                {
                  id: year.id,
                  name: this.serverTranslate(year.name)
                }
            )
        );
      });
      return years;
    },
    dOBRules() {
      return this.$store.state.rules.dOBRules(this.cardType);
    },
    minDOB() {
      let minDate = new Date();
      minDate.setFullYear(minDate.getFullYear() - 50);
      return minDate.toISOString();
    },
    maxDOB() {
      let maxDate = new Date();
      maxDate.setFullYear(maxDate.getFullYear() - 14);
      return maxDate.toISOString();
    },
    divisionTypeRule() {
      if (this.divisionTypesComputed.length > 0) {
        return [
          value =>
              value !== null && value !== "" ||
              this.$t("REQUIRED_FIELD")
        ];
      }
      return [true];
    }
    ,
    totalRules() {
      return this.$store.state.rules.totalRules(
          this.preQualYear,
          this.currentYearId
      );
    },
    otherCertificateRules() {
      return this.$store.state.rules.otherCertificateRules(
          this.foreignCertificate
      );
    },
    requiredRule() {
      return this.$store.state.rules.requiredRule;
    },
    nonRequiredRule() {
      return this.$store.state.rules.nonRequiredRule;
    },
    arNameRules() {
      return this.$store.state.rules.arNameRules;
    },
    enNameRules() {
      return this.$store.state.rules.enNameRules;
    },
    phoneRules() {
      return this.$store.state.rules.phoneRules;
    },
    photoRules() {
      return this.$store.state.rules.photoRules;
    }
  },
  created() {
    this.getUserProfileData();
  },
  data() {
    return {
      egyptianCertificates: [],
      egyptianCertificate: "",
      isEgyptianCertificate: false,
      menu: false,
      valid: true,
      hasImage: false,
      isImageDeleted: false,
      isSubmitting: false,
      isEquationCertificate: false,
      isForeignCertificate: false,
      isAnotherEquationCertificate: false,
      panel: [0, 1, 2],

      // App Data
      currentSemName: "",
      currentSemId: "",
      currentYearName: "",
      currentYearId: "",
      countriesList: [],
      addressStatesList: [],
      addressCitiesList: [],

      birthCountriesList: [],
      birthStatesList: [],
      birthCitiesList: [],

      certificateTypes: [],
      divisionTypes: [],
      equationCertificateTypes: [],
      foreignCertificates: [],
      years: [],

      // User Data
      arName: "",
      enName: "",
      email: "",
      cardID: "",
      cardType: "",
      profilePicture: null,
      nationalityCountry: "",
      addressCountry: "",
      addressState: "",
      addressCity: "",
      birthPlaceCountry: "",
      birthPlaceState: "",
      birthPlaceCity: "",
      gender: 13,
      religion: 84,
      mobile: "",
      telephone: "",
      dOB: "",
      certificateType: "",
      divisionType: null,
      preQualCountry: "",
      equationCertificateType: "",
      foreignCertificate: "",
      otherCertificateText: "",
      total: "",
      preQualYear: "",
      pullFromGsApi: false,

      bindProps: {
        mode: "international",
        defaultCountry: "EG",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: this.$t("ADMISSION_DATA.STEP1.PHONE"),
        required: true,
        enabledCountryCode: true,
        enabledFlags: true,
        preferredCountries: ["EG"],
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: "on",
        name: "telephone",
        maxLen: 25,
        wrapperClasses: "",
        inputClasses: "error--text",
        customValidate: false,
        regionCode: "EG",
        dropdownOptions: {
          disabledDialCode: true
        },
        inputOptions: {
          showDialCode: false
        },
        international: ""
      }
    };
  },
  methods: {
    IsValid(model) {
      this.bindProps.regionCode = model.regionCode;
      this.bindProps.international = model.number.international;
      if (!model.valid) this.bindProps.inputClasses = "error--text";
      else this.bindProps.inputClasses = "success-text";
    },
    isNotEmpty(str) {
      return !(!str || 0 === str.length || /^\s*$/.test(str));
    },
    updateBirthdayAndGender() {
      this.gender = this.extractGender(this.cardType, this.cardID);
      this.dOB = this.extractBirthDate(this.cardType, this.cardID);
    },
    changeImageConfirm() {
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "UserData.PIC_DELETE_CONFIRMATION", {
            width: "410px"
          })
          .then(confirm => {
            if (confirm) {
              this.hasImage = false;
              this.isImageDeleted = true;
              this.profilePicture = null;
            }
          });
    },
    getStates(type = 'address') {
      let param = {countryId: this.addressCountry}
      if (type === 'address') {
        this.addressStatesList = [];
        this.addressCitiesList = [];
        this.addressState = "";
        this.addressCity = "";
      } else if (type === "birthPlace") {
        this.birthStatesList = [];
        this.birthCitiesList = [];
        this.birthPlaceCity = "";
        this.birthPlaceState = "";
        param = {countryId: this.birthPlaceCountry}
      }

      this.$http
          .post("/api/regions_data/get_states/",
              param)

          .then(response => {
            // Check the type parameter to determine which data property to update
            if (type === "address") {
              this.addressStatesList = response.data.data;
            } else if (type === "birthPlace") {
              this.birthStatesList = response.data.data;
            }
          });


      // .then(
      //     if(type=='address'){
      //       res => (this.states = res.data.data)
      //     }
      //     else if(type=='birthPlace')
      //       {
      //       res => (this.birthStatesList = res.data.data)
      //     }
      //
      //
      // );
    },
    getCities(type = 'address') {
      let param = {
        countryId: this.addressCountry,
        stateId: this.addressState
      }
      if (type === 'address') {
        this.addressCitiesList = [];
        this.addressCity = "";
      } else if (type === "birthPlace") {
        param = {
          countryId: this.birthPlaceCountry,
          stateId: this.birthPlaceState
        }
        this.birthCitiesList = [];
        this.birthPlaceCity = "";
      }

      this.$http
          .post("/api/regions_data/get_cities/", param)
          .then(response => {
            // Check the type parameter to determine which data property to update
            if (type === "address") {
              this.addressCitiesList = response.data.data
            } else if (type === "birthPlace") {
              this.birthCitiesList = response.data.data;
            }
          });
    },
    getUserProfileData() {
      this.$http.post("/api/students_data/get_profile_data/", {'userProfile': 'true'}).then(response => {
        const data = response.data.data;
        Object.keys(data).forEach(key => {
          this.$data[key] = data[key] || "";
        });
        this.birthCountriesList = this.countriesList
        this.hasImage = this.isNotEmpty(this.profilePicture);
        this.profilePicture = this.hasImage ? this.profilePicture : null;
        this.years = this.years ? this.years : [];
        this.preQualYear = data.preQualYear
            ? data.preQualYear
            : data.currentYearId;
      });
    },
    submitForm() {
      if (
          !(
              this.$refs.editForm.validate() &&
              !!this.mobile &&
              this.bindProps.inputClasses !== "error--text"
          )
      ) {
        let formInputsRefs = Object.keys(this.$refs);
        formInputsRefs.reverse().forEach(input => {
          let inputElement = this.$refs[input];
          if (inputElement) {
            if (inputElement.valid === false) {
              inputElement.focus();
            }
          }
        });
        this.isSubmitting = false;
        this.$toasted.show(this.$t("COMPLETE_DATA_ERROR"), {
          type: "error",
          icon: "error_outline",
          theme: "bubble",
          position: "bottom-left",
          duration: 5000
        });
        return;
      }

      this.isSubmitting = true;

      let data = new FormData();

      let profileImageStatus = 0;
      data.append("profilePicture", "");
      if (!!this.profilePicture && this.profilePicture instanceof File) {
        profileImageStatus = 1;
        data.set("profilePicture", this.profilePicture);
      } else if (!this.hasImage && this.isImageDeleted) {
        profileImageStatus = 2;
        data.set("profilePicture", "");
      } else {
        profileImageStatus = 0;
        data.delete("profilePicture");
      }

      let userData = {
        arName: this.arName,
        enName: this.enName,
        email: this.email,
        cardID: this.cardID,
        cardType: this.cardType,
        nationalityCountry: this.nationalityCountry,
        addressCountry: this.addressCountry,
        addressState: this.addressState,
        addressCity: this.addressCity,
        birthPlaceCountry: this.birthPlaceCountry,
        birthPlaceState: this.birthPlaceState,
        birthPlaceCity: this.birthPlaceCity,
        gender: this.gender,
        religion: this.religion,
        mobile: this.bindProps.international || "",
        regionCode: this.bindProps.regionCode,
        telephone: this.telephone,
        dOB: this.dOB,
        certificateType: this.certificateType,
        divisionType: this.divisionType,
        preQualCountry: this.preQualCountry,
        equationCertificateType: this.isEquationCertificate
            ? this.equationCertificateType
            : "",
        foreignCertificate: this.isForeignCertificate
            ? this.foreignCertificate
            : "",
        egyptianCertificate: this.isEgyptianCertificate
        ? this.egyptianCertificate
        : "",
        otherCertificateText: this.isAnotherEquationCertificate
            ? this.otherCertificateText
            : "",
        total: this.total,
        preQualYear: this.preQualYear,
        profileImageStatus: profileImageStatus
      };

      data.append("Data", JSON.stringify(userData));

      this.$http
          .put("/api/students_data/save_profile_data/", data, {
            headers: {
              "Content-Type": `multipart/form-data; boundary=${data._boundary}`
            }
          })
          .then(res => {
            this.$toasted.show(this.serverTranslate(res.data.message), {
              type: "success",
              icon: "check_circle_outline",
              duration: 5000,
              theme: "bubble",
              position: "bottom-left"
            });
            setTimeout(() => {
              this.$router.push({name: "ViewProfile"});
            }, 1500);
          })
          .catch(errors => {
            this.isSubmitting = false;
            this.$toasted.show(
                this.serverTranslate(errors.response.data.message),
                {
                  type: "error",
                  icon: "error_outline",
                  theme: "bubble",
                  position: "bottom-left",
                  duration: 3000
                }
            );
          });
    },
    cancel() {
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "UserData.CANCEL_CONFIRMATION", {
            width: "410px"
          })
          .then(confirm => {
            if (confirm) {
              this.$router.push({name: "ViewProfile"});
            }
          });
    },
    counterValue(value) {
      return (value || "").trim().length;
    }
  },
  watch: {
    divisionTypesComputed: {
    immediate: true,
    handler(newList) {
      if (!newList || !newList.length) return;
      const exists = newList.some(
        d => d.id === Number(this.divisionType)
      );
      if (exists) {
        // ✨ force Vuetify to re-bind
        const val = Number(this.divisionType);
        this.divisionType = null;
        this.$nextTick(() => {
          this.divisionType = val;
        });
      }
    }
  },
    locale() {
      this.$refs.editForm.validate();
    },
    cardID() {
      if (this.cardType === 1) {
        this.updateBirthdayAndGender();
      }
    },
    nationalityCountry(value) {
      this.cardType = value === 1 ? 1 : 2;
    },
    dOB() {
      if (this.cardType === 1) {
        this.updateBirthdayAndGender();
      }
    },
    certificateType(value) {
  this.isEquationCertificate = value === 17;

  if (!this.isEquationCertificate) {
    this.preQualCountry = 1;

    this.equationCertificateType = "";
    this.foreignCertificate = "";
    this.egyptianCertificate = "";
    this.otherCertificateText = "";

    this.isForeignCertificate = false;
    this.isEgyptianCertificate = false;
    this.isAnotherEquationCertificate = false;
  }

  this.divisionType = null;

  this.$nextTick(() => {
    if (this.$refs.divisionType) {
      this.$refs.divisionType.validate(true);
    }
  });
}
    ,
    equationCertificateType(value) {

  this.isForeignCertificate = value === 22;
  this.isEgyptianCertificate = value === 61;
      // this.isForeignCertificate = this.isEquationCertificate && (value === 22 || value === 61);
    },
    isEquationCertificate(value) {
  this.isForeignCertificate =
      value && this.equationCertificateType === 22;

  this.isEgyptianCertificate =
      value && this.equationCertificateType === 61;
},

    foreignCertificate(value) {
      this.isAnotherEquationCertificate =
          this.isForeignCertificate && value === 32;
    },
    isForeignCertificate(value) {
      this.isAnotherEquationCertificate =
          value && this.foreignCertificate === 32;
    }
  }
};
</script>

<style scoped></style>
